module.exports = __webpack_public_path__ + "static/img/channel-1.3b97fcf5.png";